export default __webpack_public_path__ + "static/media/error-illustration.b3b48aed.png";